import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ActionCardIconComponent } from '../../atoms/cards/action-card/action-card-icon.component';
import { CardTopHeader } from '../../atoms/card-top-header/card-top-header.component';
import { IconComponent } from '../../atoms/icon/icon.component';

@Component({
  selector: 'ui-header-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardIconComponent, CardTopHeader, IconComponent],
  template: `
    <div class="flex flex-col gap-y-7">
      <div class="flex justify-start items-center gap-x-4">
        <ui-action-card-icon icon class="{{ iconClass() }}" [icon]="icon()" />
        <div class="flex flex-row justify-between w-full">
          <ui-card-top-header [title]="title()" [subtitle]="subtitle()" />
          <div class="flex gap-x-2 text-xs text-neutral-7 leading-none">
            <ui-icon icon="clock-circle" />
            <span>{{ infoLabel() }}</span>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class HeaderCardComponent {
  title = input.required<string>();
  subtitle = input.required<string>();
  infoLabel = input.required<string>();
  icon = input.required<string>();
  iconClass = input.required<string>();
}
